var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9086 4C13.9086 5.10457 13.0541 6 12 6C10.9459 6 10.0914 5.10457 10.0914 4C10.0914 2.89543 10.9459 2 12 2C13.0541 2 13.9086 2.89543 13.9086 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.506 7.13118L4.10198 20.5528C3.78473 21.2177 4.24612 22 4.95551 22H19.0445C19.7539 22 20.2153 21.2177 19.898 20.5528L13.494 7.13118C13.0445 7.36718 12.537 7.5 12 7.5C11.463 7.5 10.9555 7.36718 10.506 7.13118Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat5);
export default __webpack_public_path__ + "static/media/hat-5.457356e40c1526a2742aa6e4fddb1991.svg";
export { ForwardRef as ReactComponent };